// Platform detection utilities for React Native vs Web
const isReactNative = ()=>{
    return typeof navigator !== 'undefined' && navigator.product === 'ReactNative';
};
const isWeb = ()=>{
    return typeof window !== 'undefined' && typeof window.document !== 'undefined';
};
// TODO: Implement platformRestart for React Native
// Platform-specific restart functionality
const platformRestart = (reason)=>{
    if (isReactNative()) {
        console.error('RNRestart not available: please implement platformRestart', reason);
    }
};

export { isReactNative, isWeb, platformRestart };
//# sourceMappingURL=platform.js.map
